import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import AutTable from '../../blocks/aut-grid-table';
import Conditional from '../../common/conditional';
import Form from '../../common/form';
import VIRemarkItemForm from './viRemarkItemForm';

import * as models from '../../../utils/models';

interface ReportRemark {
	id: number;
	remark: string;
}

class VIReportSummaryForm extends Form {
	state = {
		data: { summary: '', remarks: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		summary: Joi.string().min(10).required().label('Summary'),
		remarks: Joi.array()
			.min(0)
			.items(
				Joi.object({
					id: Joi.number().required().label('S/N'),
					remark: Joi.string()
						.min(3)
						.required()
						.label('Remarks & Recommendation / Action(s) Taken'),
				})
			)
			.required()
			.label('Remarks & Recommendations'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	handleAddRemark = (remark: string) => {
		const data: any = { ...this.state.data };
		data.remarks.push({ id: data.remarks.length + 1, remark });

		this.setState({ data });
	};

	handleDeleteRemark = (remark: ReportRemark) => {
		const data = { ...this.state.data };
		data.remarks = data.remarks.filter((r: ReportRemark) => r.id !== remark.id);

		this.setState({ data });
	};

	getCompletedData = (): models.VIReportSummaryData => {
		const data = { ...this.state.data } as any;
		data.remarks = data.remarks.map((r: ReportRemark) => r.remark);

		return data;
	};

	doSubmit = (): void => {
		this.props.onProceed(this.getCompletedData());
	};

	render() {
		return (
			<React.Fragment>
				<VIRemarkItemForm onAddRemark={this.handleAddRemark} />

				<Conditional isVisible={this.state.data.remarks.length > 0}>
					<div className="my-4 divider"></div>

					<AutTable
						data={this.state.data.remarks}
						tableColumns={columns}
						onDeleteItem={this.handleDeleteRemark}
					/>

					<div className="my-4 divider"></div>
				</Conditional>

				<form autoComplete="off" onSubmit={this.handleSubmit}>
					{this.renderInput({
						name: 'summary',
						placeholder: 'Enter Report Summary',
						label: 'Summary',
						type: 'text',
					})}

					{this.renderButton('Submit')}
				</form>
			</React.Fragment>
		);
	}
}

const columns: models.Column[] = [
	{
		path: 'id',
		label: 'S/N',
	},
	{
		path: 'remark',
		label: 'Remark',
	},
];

export default VIReportSummaryForm;
